import useSWR from 'swr';
import useCustomerId from '../useCustomerId';

/** Obtains a list of segments */
const useUserSegmentsProspect = (allowRequest = true) => {
  const { customerId } = useCustomerId();

  const path = `/v2/partner/customer/${customerId}/segment`;

  const { data, isLoading, error } = useSWR(() => (allowRequest && customerId ? path : false), {
    revalidateOnFocus: false,
  });

  const sortedSegments = data?.sort((a: { name: string }, b: { name: string }) =>
    a.name.localeCompare(b.name)
  );

  return { data: sortedSegments, isLoading, error };
};

export default useUserSegmentsProspect;
